import React from 'react'

const EditIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_2644_4415)">
<path d="M9.38245 2.58998C9.87924 2.05173 10.1276 1.78261 10.3916 1.62563C11.0285 1.24685 11.8127 1.23507 12.4602 1.59456C12.7286 1.74354 12.9846 2.00509 13.4967 2.52818C14.0087 3.05128 14.2648 3.31282 14.4106 3.58696C14.7625 4.24842 14.751 5.04954 14.3802 5.70014C14.2265 5.96978 13.9631 6.22352 13.4362 6.73101L7.16706 12.7692C6.16856 13.7309 5.66931 14.2118 5.04535 14.4555C4.42139 14.6992 3.73545 14.6813 2.36356 14.6454L2.1769 14.6405C1.75925 14.6296 1.55043 14.6241 1.42904 14.4864C1.30765 14.3486 1.32422 14.1359 1.35737 13.7105L1.37536 13.4794C1.46865 12.282 1.5153 11.6833 1.74912 11.1452C1.98294 10.607 2.38627 10.17 3.19293 9.29601L9.38245 2.58998Z" stroke="#616161" stroke-width="1.33" stroke-linejoin="round"/>
<path d="M8.66669 2.66699L13.3334 7.33366" stroke="#616161" strokeWidth="1.33" strokeLinejoin="round"/>
<path d="M9.33331 14.667L14.6666 14.667" stroke="#616161" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_2644_4415">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
  )
}

export default EditIcon